export default __webpack_public_path__ + "static/media/biofit-builder-series-KX.9dfa87f6.png";